var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 5C5.39131 5 4.96738 5.17559 4.65482 5.48815C4.34226 5.80071 4.16667 6.22464 4.16667 6.66667V15.4882L6.07741 13.5774C6.23369 13.4211 6.44565 13.3333 6.66667 13.3333H14.1667C14.6087 13.3333 15.0326 13.1577 15.3452 12.8452C15.6577 12.5326 15.8333 12.1087 15.8333 11.6667V6.66667C15.8333 6.22464 15.6577 5.80071 15.3452 5.48815C15.0326 5.17559 14.6087 5 14.1667 5H5.83333ZM3.47631 4.30964C4.10143 3.68452 4.94928 3.33333 5.83333 3.33333H14.1667C15.0507 3.33333 15.8986 3.68452 16.5237 4.30964C17.1488 4.93476 17.5 5.78261 17.5 6.66667V11.6667C17.5 12.5507 17.1488 13.3986 16.5237 14.0237C15.8986 14.6488 15.0507 15 14.1667 15H7.01184L3.92259 18.0893C3.68426 18.3276 3.32583 18.3989 3.01443 18.2699C2.70304 18.1409 2.5 17.8371 2.5 17.5V6.66667C2.5 5.78261 2.85119 4.93476 3.47631 4.30964ZM5.83333 7.5C5.83333 7.03976 6.20643 6.66667 6.66667 6.66667H13.3333C13.7936 6.66667 14.1667 7.03976 14.1667 7.5C14.1667 7.96024 13.7936 8.33333 13.3333 8.33333H6.66667C6.20643 8.33333 5.83333 7.96024 5.83333 7.5ZM5.83333 10.8333C5.83333 10.3731 6.20643 10 6.66667 10H11.6667C12.1269 10 12.5 10.3731 12.5 10.8333C12.5 11.2936 12.1269 11.6667 11.6667 11.6667H6.66667C6.20643 11.6667 5.83333 11.2936 5.83333 10.8333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f2233d59f721c842cbb434fe7a9dec31.svg";
export { ForwardRef as ReactComponent };